export const _en = {
    toggleDeleted: {
        label: "Display deleted data"
    },
    firstRow: {
        addButton: {
            label: "Add"
        },
        modal: {
            label: "Training product creation"
        }
    },
    secondRow: {
        addButon: {
            label: "Add"
        },
        modal: {
            label: "Training product creation"
        }
    },
    thirdRow: {
        tabs: {
            propertie: {
                label: "Properties"
            }
        }
    },
    dialog: {
        new: {
            title: "New"
        },
        edit: {
            title: "Edit",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        duplicate: {
            title: "Duplicate",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        delete: {
            warningTitle: "Would you like to delete: {{item}} ?"
        }
    },
    counter: {
        addButton: {
            label: "Add a counter"
        },
        modal: {
            title: "Add a counter"
        }
    }
};

export const _fr = {
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    firstRow: {
        addButton: {
            label: "Ajouter"
        },
        modal: {
            label: "Ajout"
        }
    },
    secondRow: {
        addButton: {
            label: "Préfixe/Code de stage"
        },
        modal: {
            label: "Ajout d'un préfixe / code de stage"
        }
    },
    thirdRow: {
        tabs: {
            propertie: {
                label: "Propriétés"
            }
        }
    },
    dialog: {
        new: {
            title: "Nouveau"
        },
        edit: {
            title: "Édition d'un préfixe / code de stage",
            buttons: {
                save: "Éditer",
                cancel: "Annuler"
            }
        },
        duplicate: {
            title: "Duplication d'un préfixe / code de stage",
            buttons: {
                save: "Dupliquer",
                cancel: "Annuler"
            }
        },
        delete: {
            warningTitle: "Voulez vous supprimer : {{item}} ?"
        }
    },
    counter: {
        addButton: {
            label: "Compteur de préfixe / code de stage"
        },
        modal: {
            title: "Ajout d'un compteur"
        }
    }
};